import{useDisposables as r}from'./use-disposables.js';import{useEvent as s}from'./use-event.js';function m(){let e=r();return s(o=>{e.dispose(),e.nextFrame(o)})}export{m as useFrameDebounce};
